import { UIReservationStatus } from '@core/models';
import moment from 'moment';
import { create } from 'zustand';

export enum BookingAppTabKey {
  Timeline = 'timeline',
  Reservation = 'reservation',
  Setting = 'setting',
}

export enum ReservationGroupBy {
  Date = 'Date',
}

export interface BookingAppTourStore {
  selectedTabKey: BookingAppTabKey;
  setSelectedTabKey: (key: BookingAppTabKey) => void;
  selectedGroupdBy: ReservationGroupBy;
  setSelectedGroupBy: (key: ReservationGroupBy) => void;
  selectedStatus: UIReservationStatus;
  setSelectedStatus: (key: UIReservationStatus) => void;
  selectedDate: number;
  setSelectedDate: (date: number) => void;
  running: boolean;
  setRunning: (state: boolean) => void;
}

export const useBookingAppTourStore = create<BookingAppTourStore>()((set: any) => ({
  selectedDate: moment().unix(),
  setSelectedDate(date: number) {
    set(() => ({
      selectedDate: date,
    }));
  },
  selectedTabKey: BookingAppTabKey.Timeline,
  setSelectedTabKey(tabKey: BookingAppTabKey) {
    set(() => ({
      selectedTabKey: tabKey,
    }));
  },
  selectedGroupdBy: ReservationGroupBy.Date,
  setSelectedGroupBy(groupBy: ReservationGroupBy) {
    set(() => ({
      selectedGroupdBy: groupBy,
    }));
  },
  selectedStatus: UIReservationStatus.All,
  setSelectedStatus(status: UIReservationStatus) {
    set(() => ({
      selectedStatus: status,
    }));
  },
  running: false,
  setRunning(running) {
    set(() => ({
      running: running,
    }));
  },
}));
